"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

var _WidgetBase = _interopRequireDefault(require("../Widget/WidgetBase"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _UserIcon = _interopRequireDefault(require("./UserIcon"));

var _Owners = require("../Owners");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const getContrast = color => {
  color = (0, _color.default)(color);
  let contrast;

  if (color.isDark()) {
    contrast = 'white';
  } else {
    contrast = 'black';
  }

  return contrast;
};

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    position: "relative"
  },
  header: {
    backgroundColor: props => {
      return props.backgroundColor;
    },
    color: props => {
      return getContrast(props.backgroundColor);
    },
    width: "100%",
    height: theme.spacing(15),
    // 120px
    display: "flex",
    alignItems: "center"
  },
  icon: {
    fontSize: theme.spacing(8),
    margin: theme.spacing(2)
  },
  info: {
    display: ""
  },
  title: {
    fontSize: "18px",
    lineHeight: "20px",
    fontWeight: "normal"
  },
  email: {
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "normal",
    opacity: 0.85
  },
  body: {
    display: "block",
    position: "absolute",
    top: theme.spacing(15),
    right: 0,
    bottom: 0,
    left: 0
  }
}));

const OwnerWidget = (_ref) => {
  let _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      onSelect = _ref.onSelect,
      props = _objectWithoutPropertiesLoose(_ref, ["user", "onSelect"]);

  const _useState = (0, _react.useState)(false),
        overflow = _useState[0],
        setOverflow = _useState[1];

  const bodyRef = (0, _react.useRef)();
  const imageUrl = user.imageUrl || props.imageUrl;
  const initials = user.initials || props.initials;
  const name = user.name || props.name || "Name";
  const email = user.email || props.email;
  const owners = user.owners || props.owners;
  const theme = user.theme || props.theme;
  const backgroundColor = theme && theme.primaryColor || "#ccc";
  const classes = useStyles({
    backgroundColor
  });
  (0, _react.useEffect)(() => {
    const height = bodyRef.current && bodyRef.current.offsetHeight;
    const itemsHeight = owners && owners.length && owners.length * 57;

    if (itemsHeight > height) {
      setOverflow(true);
    }
  });
  return _react.default.createElement(_WidgetBase.default, _extends({}, props, {
    classes: classes
  }), _react.default.createElement("header", {
    className: classes.header
  }, _react.default.createElement(_UserIcon.default, {
    className: classes.icon,
    imageUrl: imageUrl,
    name: name,
    initials: initials,
    className: classes.icon
  }), _react.default.createElement("div", {
    className: classes.info
  }, _react.default.createElement(_Typography.default, {
    component: "h2",
    className: classes.title
  }, name), _react.default.createElement(_Typography.default, {
    component: "h3",
    className: classes.email
  }, email))), _react.default.createElement("div", {
    className: classes.body,
    ref: bodyRef
  }, overflow && _react.default.createElement(_Owners.FilterOwnersControlled, {
    owners: owners,
    onSelect: onSelect
  }), !overflow && _react.default.createElement(_Owners.OwnersList, {
    owners: owners,
    onSelect: onSelect
  })));
};

OwnerWidget.defaultProps = {
  type: "owner",
  size: "4:6"
};
var _default = OwnerWidget;
exports.default = _default;
module.exports = exports.default;